import { TableCell, TableContainer, TableRow } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, createGlobalStyle, css } from "styled-components";
import { OrderStatus } from "../../../../models/Order";

export const LocationInputtWrap = styled.div`
	display: flex;
	align-items: center;
	margin-bottom:20px;
	@media screen and (max-width: 768px) {
flex-direction: column;
	}
`;
export const LocationTableBodyAdminContentTr = styled(TableRow)``;

export const LocationTableBodyAdminContentTd = styled(TableCell)`
	font-size: 13px;
`;

export const FomrmLocationInput = styled.input`
	color: #6b7280;
	display: flex;
	padding: 0px 16px;
	justify-content: space-between;
	align-items: center;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	font-family: inherit;
	color: #111827;
	min-width:100px;
	padding: 10px;
	margin-right: 20px;
	@supports (-webkit-overflow-scrolling: touch) {
		& {
			font-size: 16px;
		}
	}
			@media screen and (max-width: 768px) {
width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
	}
`;